import { z } from "zod";
import { AccountItemSchema } from "./account-item";
import { ResultDataSchema } from "../result-data/result-data";

export const AccountResultSchema = ResultDataSchema.extend({
  Results: AccountItemSchema.array(),
});

export type AccountResultType = z.infer<typeof AccountResultSchema>;
